<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">환불관리</span>
            <span class="txt">환불신청 된 내역을 확인하고 수정이 가능하며 최종 환불처리를 할 수 있습니다.</span>
        </div>

        <div class="com-search-content">
            <div class="line">
                <div class="com-calendar-wrap">
                    <single-calendar :start-date="startDate" @update="startDateUpdate"></single-calendar>
                    <div class="com-dash"><span class="dash">~</span></div>
                    <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                </div>
                <select-form
                    :select-data="['선택', ...periodTypeList]"
                    :select-value="['', ...periodTypeValueList]"
                    :selected-value="searchPeriod"
                    @update:set="(val) => (searchPeriod = val)"
                ></select-form>
                <div class="com-search-input">
                    <input
                        v-model="searchStr"
                        placeholder="이름, 연락처 입력"
                        type="text"
                        v-on:keyup.enter="onEventSearch"
                    />
                    <button class="search-btn" @click="onEventSearch">검색</button>
                </div>
            </div>
            <div class="line">
                <select-form
                    :select-data="['이용권 구분', '개인', 'OT', '듀엣', '그룹', '쿠폰', '회원권', '운동복']"
                    :select-value="['', 'P', 'O', 'D', 'G', 'C', 'T', 'S']"
                    :selected-value="ticketType"
                    @update:set="(val) => (ticketType = val)"
                ></select-form>
                <select-form
                    :select-data="['카테고리명', ...categoryList]"
                    :select-value="['', ...categoryValList]"
                    :selected-value="category"
                    @update:set="(val) => (category = val)"
                ></select-form>
                <select-form
                    :select-data="['이용권명', ...prodList]"
                    :select-value="['', ...prodValList]"
                    :selected-value="prod"
                    class="w240"
                    @update:set="(val) => (prod = val)"
                ></select-form>
                <button class="com-search-reset" @click="resetSearchFilter"></button>
            </div>
            <div class="line">
                <select-form
                    :select-data="['환불수단', '전체', '현금', '계좌이체', '카드취소']"
                    :select-value="['', '', 'L', 'B', 'C']"
                    :selected-value="returnType"
                    class="w220"
                    @update:set="(val) => (returnType = val)"
                ></select-form>
                <select-form
                    :select-data="['담당강사', ...teacherList]"
                    :select-value="['', ...teacherValueList]"
                    :selected-value="teacherStaff"
                    @update:set="(val) => (teacherStaff = val)"
                ></select-form>
                <select-form
                    :select-data="['매출직원', ...staffNameList]"
                    :select-value="['', ...staffNameValueList]"
                    :selected-value="saleStaff"
                    @update:set="(val) => (saleStaff = val)"
                ></select-form>
                <select-form
                    :select-data="['센터명', ...chainCenterType]"
                    :select-value="['', ...chainCenterTypeValue]"
                    :selected-value="selectedCenter"
                    @update:set="(val) => (selectedCenter = val)"
                ></select-form>
                <button class="com-search-reset" @click="resetSearchContent"></button>
            </div>
        </div>

        <div class="com-table-content">
            <table class="com-table">
                <colgroup>
                    <col style="width: 95px" />
                    <col style="width: 100px" />
                    <col style="width: 320px" />
                    <col style="width: 125px" />
                    <col style="width: 160px" />
                    <col style="width: 125px" />
                    <col style="width: 100px" />
                    <col style="width: 100px" />
                    <col style="width: 120px" />
                    <col style="width: 180px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <button>신청일</button>
                        </th>
                        <th>회원명</th>
                        <th>
                            <button>이용권명</button>
                        </th>
                        <th>
                            <button>총 결제금액</button>
                        </th>
                        <th>
                            <button>환불정보</button>
                        </th>
                        <th>
                            <button>환불수단</button>
                        </th>
                        <th>
                            <button>담당강사</button>
                        </th>
                        <th>
                            <button>매출직원</button>
                        </th>
                        <th>처리</th>
                        <th>
                            <button>센터명</button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(r, index) in refundList" :key="r.ccp_center_contract_id">
                        <td>{{ r.ccp_ret_apply_dt | timestampFilter }}</td>
                        <td>
                            <router-link
                                :to="{
                                    path: `/madmin/member/payment/${r.ccp_center_id}`,
                                    query: { customerId: r.ccp_center_cust_id },
                                }"
                                class="link"
                            >
                                {{ r.ccp_customer_nm }}
                            </router-link>
                        </td>
                        <td class="left">
                            <span
                                :class="{
                                    'type-1': r.ccp_ticket_type_cd == 'P',
                                    'type-2': r.ccp_ticket_type_cd == 'G',
                                    'type-3': r.ccp_ticket_type_cd == 'C',
                                    'type-4': r.ccp_ticket_type_cd == 'T',
                                    'type-5': r.ccp_ticket_type_cd == 'D',
                                    'type-6': r.ccp_ticket_type_cd == 'O',
                                    'type-8': r.ccp_ticket_type_cd == 'S',
                                }"
                                class="ico"
                            >
                                {{ convertTicket(r.ccp_ticket_type_cd) }}
                            </span>
                            <router-link
                                :to="{
                                    path: `/madmin/member/account/${r.ccp_center_id}`,
                                    query: { customerId: r.ccp_center_cust_id, contractId: r.ccp_center_contract_id },
                                }"
                                class="link"
                            >
                                {{ r.ccp_prod_nm }}
                            </router-link>
                        </td>
                        <td>{{ r.ccp_prod_buy_price | numberFormatFilter }}원</td>
                        <td>
                            <span class="info-line">
                                <span>
                                    사용금액 {{ (r.ccp_prod_buy_price - r.ccp_ret_price) | numberFormatFilter }}원
                                </span>
                                <button
                                    class="blue"
                                    @click="
                                        refundInfo(
                                            index,
                                            r.ccp_ret_yn,
                                            r.ccp_center_contract_id,
                                            r.ccp_center_cust_id,
                                            r.ccp_center_prod_id
                                        )
                                    "
                                >
                                    환불금액 {{ r.ccp_ret_price | numberFormatFilter }}원
                                </button>
                            </span>
                        </td>
                        <td>
                            {{ convertRefundType(r.ccp_ret_pay_type_cd) }}
                            <br />
                            <span v-if="r.ccp_ret_pay_type_cd == 'B'">
                                {{ r.ccp_ret_pay_bank }} {{ r.ccp_ret_pay_acc }}
                                <br />
                                {{ r.ccp_ret_pay_own }}
                            </span>
                        </td>
                        <td>{{ r.ccp_less_staff_nm }}</td>
                        <td>{{ r.ccp_sale_staff_nm }}</td>
                        <td>
                            <button
                                v-if="r.ccp_ret_yn == false"
                                class="com-btn red"
                                @click="
                                    checkRefundPopup(
                                        index,
                                        r.ccp_ret_yn,
                                        r.ccp_center_contract_id,
                                        r.ccp_center_cust_id,
                                        r.ccp_center_prod_id
                                    )
                                "
                            >
                                환불하기
                            </button>
                            <span v-if="r.ccp_ret_yn == true">
                                {{ r.ccp_ret_exec_dt | timestampFilter }}
                                <br />
                                완료
                            </span>
                        </td>
                        <td>{{ r.ccp_center_nm }}</td>
                    </tr>
                    <tr v-if="refundList == 0">
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <button class="com-btn excel" @click="excelDownload">엑셀 다운로드</button>
                <select-form
                    :select-data="['10줄보기', '20줄보기', '50줄보기', '100줄보기']"
                    class="float-right"
                ></select-form>
            </div>
            <b-pagination
                v-model="pagingInfo.page"
                :per-page="pagingInfo.limit"
                :total-rows="pagingInfo.totalItems"
                align="center"
                aria-controls="my-table"
                first-class="first"
                last-class="last"
                next-class="next"
                prev-class="prev"
                @change="handlerPagenation($event)"
            ></b-pagination>
        </div>

        <!-- 환불 신청 레이어 팝업 -->
        <div v-show="refundPop" class="layer-pop square">
            <div class="view-content w1425">
                <button class="close" @click="refundPop = false"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <loading-spinner v-if="returnIsLoading"></loading-spinner>
                    <div v-else class="input-info-box">
                        <span class="title">환불 신청</span>
                        <!-- 이용권 정보 -->
                        <div class="use-info-cnt">
                            <span class="title">이용권 정보</span>
                            <div class="line">
                                <div class="input-wrap">
                                    <span class="tit">이름</span>
                                    <input v-model="refundUserInfo.ccp_customer_nm" class="w220" readonly type="text" />
                                </div>
                                <div class="input-wrap">
                                    <span class="tit">총 결제금액</span>
                                    <input
                                        class="w440"
                                        readonly
                                        type="text"
                                        v-bind:value="`${numberFormat(refundUserInfo.ccp_prod_buy_price)}`"
                                    />
                                </div>
                            </div>
                            <!-- 이용권일 경우 -->
                            <span class="title blue">
                                {{
                                    convertTicket(refundUserInfo.ccp_ticket_type_cd) + ' ' + refundUserInfo.ccp_prod_nm
                                }}
                            </span>
                            <div class="line">
                                <div class="input-wrap">
                                    <span class="tit">담당강사</span>
                                    <input
                                        :value="refundUserInfo.ccp_less_staff_nm"
                                        class="w220"
                                        readonly
                                        type="text"
                                    />
                                </div>
                                <div class="input-wrap">
                                    <span class="tit">매출직원</span>
                                    <input
                                        :value="refundUserInfo.ccp_sale_staff_nm"
                                        class="w220"
                                        readonly
                                        type="text"
                                    />
                                </div>
                                <!--                                {{ t.cc_less_join_cnt + t.cc_less_absn_cnt }}</span>/{{ t.cc_less_cnt }} 회-->
                                <div class="input-wrap">
                                    <span class="tit">사용횟수</span>
                                    <input
                                        :value="`${
                                            parseInt(
                                                refundUserInfo.ccp_less_join_cnt !== null
                                                    ? refundUserInfo.ccp_less_join_cnt
                                                    : 0
                                            ) +
                                            parseInt(
                                                refundUserInfo.ccp_less_absn_cnt !== null
                                                    ? refundUserInfo.ccp_less_absn_cnt
                                                    : 0
                                            )
                                        } / ${refundUserInfo.ccp_less_cnt} 회`"
                                        class="w220"
                                        readonly
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div class="line">
                                <div class="input-wrap">
                                    <span class="tit">유효기간</span>
                                    <div class="com-calendar-wrap">
                                        <single-calendar
                                            :disabled="true"
                                            :start-date="refundUserInfo.ccp_exp_start_dt | timestampFilter"
                                        ></single-calendar>
                                        <div class="com-dash"><span class="dash">~</span></div>
                                        <single-calendar
                                            :end-date="refundUserInfo.ccp_ret_exp_end_dt | timestampFilter"
                                            @update="(val) => (returnExpireEndDt = val)"
                                        ></single-calendar>
                                    </div>
                                    <span class="txt red">※ 환불 시 이용권의 종료일자를 선택하세요.</span>
                                </div>
                            </div>
                            <div class="line">
                                <div class="input-wrap">
                                    <span class="tit">
                                        사용금액
                                        <span class="imp">*</span>
                                        <div class="com-tooltip"><button class="icon"></button></div>
                                    </span>
                                    <input :value="numberFormat(returnPrice)" class="w220" readonly type="text" />
                                    <span class="txt">원</span>
                                </div>
                                <div class="input-wrap">
                                    <span class="tit">
                                        환불금액
                                        <span class="imp">*</span>
                                        <div class="com-tooltip"><button class="icon"></button></div>
                                    </span>
                                    <input
                                        :value="numberFormat(refundUserInfo.ccp_ret_price)"
                                        class="w220"
                                        readonly
                                        type="text"
                                    />
                                    <span class="txt">원</span>
                                </div>
                            </div>
                        </div>
                        <span class="bar-line"></span>
                        <span class="title">환불 정보</span>
                        <div class="line">
                            <div class="input-wrap">
                                <span class="tit">
                                    환불직원
                                    <span class="imp">*</span>
                                    <div class="com-tooltip"><button class="icon"></button></div>
                                </span>
                                <select-form
                                    :disabled="returnInput"
                                    :select-data="['환불직원', ...staffNameList]"
                                    :select-value="['', ...staffNameValueList]"
                                    :selected-value="refundUserInfo.ccp_ret_staff_id"
                                    class="w220"
                                    @update:set="(val) => (refundStaff = val)"
                                ></select-form>
                            </div>
                            <div class="input-wrap">
                                <span class="tit">
                                    환불 신청일
                                    <span class="imp">*</span>
                                </span>
                                <single-calendar
                                    :date="refundUserInfo.ccp_ret_apply_dt | timestampFilter"
                                    class="w220"
                                    readonly
                                    @update="(val) => (refundDate = val)"
                                ></single-calendar>
                            </div>
                        </div>
                        <div class="line">
                            <div class="input-wrap">
                                <span class="tit">마일리지 차감</span>
                                <input
                                    :value="refundUserInfo.ccp_ret_mileage_price"
                                    class="w220"
                                    readonly
                                    type="text"
                                />
                                <span class="input-txt">원 차감됩니다.</span>
                            </div>
                        </div>
                        <div class="line">
                            <div class="input-wrap">
                                <span class="tit">
                                    환불수단
                                    <span class="imp">*</span>
                                </span>
                                <div class="sub">
                                    <div class="com-radio">
                                        <input
                                            id="radio-acc-1"
                                            v-model="returnPayType"
                                            name="radio-acc"
                                            type="radio"
                                            value="L"
                                        />
                                        <label for="radio-acc-1">현금</label>
                                    </div>
                                    <div class="com-radio">
                                        <input
                                            id="radio-acc-2"
                                            v-model="returnPayType"
                                            name="radio-acc"
                                            type="radio"
                                            value="B"
                                        />
                                        <label for="radio-acc-2">계좌이체</label>
                                    </div>
                                    <div class="com-radio">
                                        <input
                                            id="radio-acc-3"
                                            v-model="returnPayType"
                                            name="radio-acc"
                                            type="radio"
                                            value="C"
                                        />
                                        <label for="radio-acc-3">카드취소</label>
                                    </div>
                                </div>
                                <div v-if="returnPayType !== 'B'" class="sub">
                                    <input
                                        :value="numberFormat(refundUserInfo.ccp_ret_price)"
                                        class="w220"
                                        placeholder="환불합계 금액"
                                        readonly
                                        type="text"
                                    />
                                </div>
                                <div v-if="returnPayType === 'B'" class="sub">
                                    <input
                                        :value="numberFormat(refundUserInfo.ccp_ret_price)"
                                        class="w220"
                                        placeholder="환불합계 금액"
                                        readonly
                                        type="text"
                                    />
                                    <input
                                        :value="refundUserInfo.ccp_ret_pay_bank"
                                        class="w220"
                                        placeholder="은행명 입력"
                                        type="text"
                                    />
                                    <input
                                        :value="refundUserInfo.ccp_ret_pay_own"
                                        class="w220"
                                        placeholder="예금주 입력"
                                        type="text"
                                    />
                                    <input
                                        :value="refundUserInfo.ccp_ret_pay_acc"
                                        class="w220"
                                        placeholder="계좌번호 입력"
                                        type="text"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <div class="input-wrap w100p">
                                <span class="tit">환불사유 및 메모</span>
                                <div class="sub">
                                    <textarea
                                        v-model="refundUserInfo.ccp_ret_memo"
                                        placeholder="내용을 입력해주세요."
                                        readonly
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="com-notice-list">
                        <ul class="list">
                            <li>※ 유효기간은 환불신청일까지로 종료되며 예약 및 입장이 불가합니다.</li>
                            <li>
                                ※ 최종 환불완료 처리는
                                <span class="blue">매출 > 환불관리</span>
                                에서 가능합니다.
                            </li>
                        </ul>
                    </div>

                    <div class="bottom-btn">
                        <button class="com-btn" @click="refundPop = false">취소</button>
                        <button v-if="!refundUserInfo.ccp_ret_yn" class="com-btn blue" @click="refundItemPost">
                            수정
                        </button>
                        <button v-if="!refundUserInfo.ccp_ret_yn" class="com-btn red" @click="onClickCancleReturn">
                            삭제
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import moment from 'moment';
import EventBus from '../../../assets/js/eventBus';
import { numberFormat, timestampToDate } from '@/assets/js/excelCommon.js';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import XLSX from 'xlsx';
import { pagingInfo } from '@/assets/js/common';
export default {
    name: 'SalesRefund',
    mixins: [MixinAllowedMenu],
    props: {},
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        prodIsT() {
            return this.refundUserInfo.ccp_prod_type_cd === 'T';
        },
        prodIsP() {
            return this.refundUserInfo.ccp_prod_type_cd === 'P';
        },
    },
    watch: {
        searchPeriod(newValue) {
            // 검색 기간 설정 변수
            this.searchPeriod = newValue;

            if (newValue === 'today') {
                // 오늘
                this.startDate = moment().format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'yesterday') {
                // 어제
                this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === 'thisMonth') {
                // 이번 달
                this.startDate = moment().startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'prevMonth') {
                // 지난 달
                this.startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === '3M') {
                // 3개월
                this.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '6M') {
                // 6개월
                this.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '12M') {
                // 12개월
                this.startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '') {
                this.initStartDate();
                this.initEndDate();
            }
            this.onSearchList();
        },
        startDate(newValue) {
            // 검색 시작일
            this.startDate = newValue;
        },
        endDate(newValue) {
            // 검색 종료일
            this.endDate = newValue;
        },
        returnType(newValue) {
            // 환불유형
            this.returnType = newValue;
            this.onSearchList();
        },
        refundStaff(newValue) {
            // 환불직원
            this.refundStaff = newValue;
        },
        saleStaff(newValue) {
            this.saleStaffId = newValue;
            this.onSearchList();
        },
        teacherStaff(newValue) {
            this.teacherStaff = newValue;
            this.onSearchList();
        },
        category(newValue) {
            this.category = newValue;
            this.onSearchList();
        },
        prod(newValue) {
            this.prod = newValue;
            this.onSearchList();
        },
        ticketType(newValue) {
            this.ticketType = newValue;
            this.onSearchList();
        },
    },
    data() {
        return {
            pagingInfo: { ...pagingInfo },
            refundPop: false, // 환불신청 팝업
            centerId: '', // 센터아이디값
            centerCustomerId: '', // 회원아이디
            centerContractId: '', // 계약아이디
            centerProductId: '', // 상품아이디
            refundList: [],

            returnIsLoading: false,
            startDate: '',
            endDate: '',
            periodTypeList: [...this.$periodTypeList],
            periodTypeValueList: [...this.$periodTypeValueList],

            searchStr: '', // 이름, 연락처 검색 파라미터
            searchPeriod: '3M', // 검색 기간 설정
            retYn: false,
            returnType: '', // 환불타입

            name: '',
            teacher: '', // 담당강사
            staff: '', // 매출직원
            prod: '',
            startDt: '',
            endDt: '',
            pay: '',
            used: '',

            centerStaffList: [], // centerStaff 이름 목록
            centerStaffValueList: [], // centerStaff ID 목록

            returnInput: false, // 환불수단 input
            refundStaff: '',

            // 등록시 요청파라미터들
            returnExpireEndDt: moment().format('YYYY-MM-DD'),
            returnPayType: '',
            returnMemo: '',
            returnMileagePrice: '',
            usePay: '',
            refundPay: '',
            refundDate: moment().format('YYYY-MM-DD'),

            staffNameList: [],
            staffNameValueList: [],
            saleStaff: '',
            teacherStaff: '',

            category: '', // 카테고리값
            teacherList: [], // 강사 직원
            teacherValueList: [],
            categoryList: [],
            categoryValList: [],
            prodList: [],
            prodValList: [],
            ticketType: '', // 이용권 유효코드

            expStartDate: '',
            expEndDate: '',
            prodTicket: '',
            returnPrice: 0, // 환불금액
            refundUserInfo: {}, // 환불 대상자 정보

            chainCenterType: [],
            chainCenterTypeValue: [],
            selectedCenter: '',

            count: 1,
        };
    },
    mounted() {
        this.goMainIfNotAllowed('SA', 5);

        this.centerId = this.cId; // 센터 Id
        this.selectedCenter = parseInt(this.cId); // 선택된 센터id
        this.init();
    },
    methods: {
        // 초기화
        init() {
            this.initStartDate(); // 검색 시작일 초기화
            this.initEndDate(); // 검색 종료일 초기화
            Promise.allSettled([
                this.onSearchList(),
                this.fetchChainCenter(),
                this.onFetchStaffList(),
                this.onFetchTeachers(),
                this.onCategoryList(),
                this.onProductList(),
            ]);
            // 조회
            // 센터 체인 조회
            // 스태프 조회
            // 강사 조회
            // 카테고리 리스트
            // 이용권리스트
        },
        async excelDownload() {
            // 엑셀 다운로드 기능구현
            const { data } = await this.getSearchListExcel(); // 엑셀용 요청값
            const excelDownloadArray = [];
            data.items.forEach((r) => {
                const temp = {};
                temp['신청일'] = timestampToDate(r.ccp_cre_dt);
                temp['회원명'] = r.ccp_customer_nm;
                temp['이용권명'] = this.convertTicket(r.ccp_ticket_type_cd) + r.ccp_prod_nm;
                temp['총결제금액'] = numberFormat(r.ccp_prod_buy_price);
                temp['환불정보'] = `${r.ccp_ret_use_price}환불금액${r.ccp_ret_price}`;
                temp['환불수단'] = this.convertRefundType(r.ccp_ret_pay_type_cd);
                temp['담당강사'] = r.ccp_less_staff_nm;
                temp['매출직원'] = r.ccp_sale_staff_nm;
                temp['처리'] = r.ccp_ret_yn ? `${moment(r.ccp_ret_exec_dt).format('YYYY-MM-DD')} 완료` : '미완료';
                temp['센터명'] = r.ccp_center_nm;

                excelDownloadArray.push(temp);
            });
            /* [Key:value,...] */
            const dataWS = XLSX.utils.json_to_sheet(excelDownloadArray); // 배열을 넣어야함.
            // cell width 설정
            const wscols = [
                { wch: 12 },
                { wch: 12 },
                { wch: 20 },
                { wch: 15 },
                { wch: 10 },
                { wch: 25 },
                { wch: 15 },
                { wch: 15 },
                { wch: 15 },
                { wch: 10 },
            ];
            dataWS['!cols'] = wscols;

            // cell height 설정
            const wsrows = [{ hpx: 30 }];
            dataWS['!rows'] = wsrows;
            const wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, dataWS, '환불관리');
            XLSX.writeFile(wb, '환불관리_리스트.xlsx');
        },
        // 엑셀용 다운로드 리스트
        getSearchListExcel() {
            return api.get(`/admin/api/center/${this.centerId}/product/retrun`, {
                // api 이름 철자 확인
                params: {
                    page: 1,
                    limit: 10000,
                    startDate: moment(this.startDate).format('YYYYMMDD'),
                    endDate: moment(this.endDate).format('YYYYMMDD'),
                    returnPayType: this.returnType, // 환불수단
                    searchStr: this.searchStr,
                    ticketType: this.ticketType, // 이용권구분
                    centerProductCategoryId: this.category, // 센터상품카테고리구분
                    centerProductId: '', // 센터상품이용권Id
                    lessonStaffId: this.teacherStaff, // 담당강사ID
                    saleStaffId: this.saleStaff, // 매출직원ID
                },
            });
        },

        async onSearchList() {
            try {
                const { data } = await this.getSearchList();
                console.log('데이터 값', data);
                this.setPageParams(data);
                this.refundList = data.items;
            } catch (error) {
                console.log(error);
                console.log('에러입니다.');
            }
        },
        // 페이지 리스트
        getSearchList() {
            // 스웨거 검색: 센터회원계약 상품 환불 페이징 목록 조회
            return api.get(`/admin/api/center/${this.centerId}/product/retrun`, {
                // api 이름 철자 확인
                params: {
                    ...this.pagingInfo,
                    startDate: moment(this.startDate).format('YYYYMMDD'),
                    endDate: moment(this.endDate).format('YYYYMMDD'),
                    returnPayType: this.returnType, // 환불수단
                    searchStr: this.searchStr,
                    ticketType: this.ticketType, // 이용권구분
                    centerProductCategoryId: this.category, // 센터상품카테고리구분
                    centerProductId: '', // 센터상품이용권Id
                    lessonStaffId: this.teacherStaff, // 담당강사ID
                    saleStaffId: this.saleStaff, // 매출직원ID
                },
            });
        },
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },

        // 한 페이지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.pagingInfo.limit = val;
            this.onSearchList();
        },

        // 페이징 이벤트
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.onSearchList();
        },

        // 검색 시작일 초기화
        initStartDate() {
            const startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
            this.startDate = startDate;
        },

        // 검색 종료일 초기화
        initEndDate() {
            const endDate = moment().format('YYYY-MM-DD');
            this.endDate = endDate;
        },

        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
            this.onSearchList();
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.endDate = val;
            this.onSearchList();
        },

        // 검색 조건 초기화
        resetSearchParams() {
            this.initStartDate(); // 시작일 검색 파라미터
            this.initEndDate(); // 종료일 검색 파라미터
            this.searchPeriod = '';
            this.searchSortType = '';
            this.searchSortColumn = '';
            this.onSearchList();
            EventBus.$emit('event:initList', 'init');
        },

        // 회원 목록 키워드 검색 이벤트
        onEventSearch(e) {
            if (this.searchStr.length > 0 && this.searchStr.length < 2) {
                return;
            }
            this.onSearchList();
        },
        convertRefundType(type) {
            if (type == 'C') {
                return '카드취소';
            } else if (type == 'L') {
                return '현금';
            } else if (type == 'B') {
                return '계좌이체';
            }
        },
        async checkRefundPopup(idx, returnYn, contractId, custId, prodId) {
            try {
                // 이용자정보 세팅
                if (confirm('환불 완료처리 하시겠습니까?') == true) {
                    this.centerCustomerId = custId;
                    this.centerContractId = contractId;
                    this.centerProductId = prodId;
                    // const { data } = await this.getSearchList();
                    this.refundUserInfo = this.refundList[idx];
                    console.log('refundUserInfo', this.refundUserInfo);
                    this.returnPrice = parseInt(this.refundList[idx].ccp_ret_price);
                    await this.completeRefund();
                    await this.onSearchList(); // 리프레쉬

                    alert('환불이 최종 완료되었습니다.');
                    // 값 바꿔주기
                } else {
                    alert('환불이 취소되었습니다.');
                    return false;
                    // 값 그대로
                }
            } catch (error) {
                console.log('환불처리가 완료되지않았습니다.');
                console.log(error);
            }
        },
        // 환불완료처리 API
        completeRefund() {
            return api.put(
                `/admin/api/center/${this.centerId}/customer/${this.centerCustomerId}/contract/${this.centerContractId}/product/${this.centerProductId}/complete-retrun`,
                {
                    returnStaffId: this.refundUserInfo.ccp_ret_staff_id,
                    returnApplyAt: this.refundUserInfo.ccp_ret_apply_dt,
                    returnPrice: this.returnPrice,
                    returnPayType: this.refundUserInfo.ccp_ret_pay_type_cd,
                    returnPayBank: this.refundUserInfo.ccp_ret_pay_bank,
                    returnPayOwn: this.refundUserInfo.ccp_ret_pay_own, // 요청값을 몰라서 하드코딩
                    returnPayAccount: this.refundUserInfo.ccp_ret_pay_acc,
                    returnMileagePrice: this.refundUserInfo.ccp_ret_mileage_price,
                    returnMemo: this.refundUserInfo.ccp_ret_memo,
                    returnUsePrice: this.refundUserInfo.returnPrice,
                }
            );
        },

        // 환불등록처리 API
        requestRefund() {
            return api.put(
                `/admin/api/center/${this.centerId}/customer/${this.centerCustomerId}/contract/${this.centerContractId}/product/${this.centerProductId}/request-retrun`,
                {
                    returnStaffId: this.refundStaff,
                    returnApplyAt: this.refundDate,
                    returnExpireEndDt: this.returnExpireEndDt,
                    returnPrice: this.refundUserInfo.ccp_ret_price,
                    returnPayType: this.refundUserInfo.ccp_ret_pay_type_cd,
                    returnPayBank: this.refundUserInfo.ccp_ret_pay_bank,
                    returnPayOwn: this.refundUserInfo.ccp_ret_pay_own, // 요청값을 몰라서 하드코딩
                    returnPayAccount: this.refundUserInfo.ccp_ret_pay_acc,
                    returnMileagePrice: this.refundUserInfo.ccp_ret_mileage_price,
                    returnMemo: this.refundUserInfo.ccp_ret_memo,
                }
            );
        },

        // 환불정보 클릭시
        async refundInfo(idx, returnYn, contractId, custId, prodId) {
            try {
                // 이용자정보 세팅
                this.centerCustomerId = custId;
                this.centerContractId = contractId;
                this.centerProductId = prodId;

                console.log(idx);
                console.log(returnYn);
                this.refundPop = true;
                this.returnInput = returnYn; // 리턴값 부여
                const { data } = await this.getSearchList();
                this.refundUserInfo = data.items[idx];
                console.log('1', data);
                console.log('환불정보 조회', this.refundUserInfo);

                this.returnPayType = data.items[idx].ccp_ret_pay_type_cd;
                this.returnPrice =
                    parseInt(data.items[idx].ccp_prod_buy_price) - parseInt(data.items[idx].ccp_ret_price);

                if (returnYn == true) {
                    // 환불이 완료되었을때
                    this.refundStaff = this.refundUserInfo.ccp_ret_staff_id;
                    // this.refundDate = this.refundUserInfo.ccp_ret_apply_dt;
                    // this.returnPrice = this.refundUserInfo.ccp_ret_use_price;
                    this.refundPay = this.refundUserInfo.ccp_ret_price;
                    console.log('값 입력');
                } else {
                    this.returnExpireEndDt = this.refundUserInfo.ccp_ret_exp_end_dt;
                    this.refundStaff = this.refundUserInfo.ccp_ret_staff_id;
                    this.refundDate = this.refundUserInfo.ccp_ret_apply_dt;
                }
            } catch (error) {
                console.log(error);
                console.log('에러');
            }
        },
        async refundItemPost() {
            try {
                // const { data } = await this.refundItem();
                // await this.completeRefund();
                // alert('환불처리가 완료되었습니다..');
                await this.requestRefund();
                alert('환불수정이 완료되었습니다..');
                this.refundPop = false;
                await this.onSearchList(); // 리프레쉬
            } catch (error) {
                console.log('등록요청 에러');
                console.log(error);
            }
        },
        // 등록요청
        // refundItem(){
        //     return api.put(`/admin/api/center/${this.centerId}/customer/${this.centerCustomerId}/contract/${this.centerContractId}/product/${this.centerProductId}/request-retrun`,{
        //             returnStaffId: this.refundStaff,
        //             returnApplyAt: moment().format('YYYY-MM-DD'),
        //             returnExpireEndDt: '2021-01-04T09:41:17.443Z',
        //             returnPrice: this.returnPrice,
        //             returnPayType: this.returnPayType,
        //             returnPayBank:'KB',
        //             returnPayOwn: 'string',
        //             returnPayAccount: 'string',
        //             returnMileagePrice: this.returnMileagePrice,
        //             returnMemo: this.returnMemo,
        //     })
        // },
        // 스태프 리스트 조회
        async onFetchStaffList() {
            try {
                const { data } = await this.getfetchStaffList();
                data.sort(
                    (
                        a,
                        b // order by 정렬
                    ) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0)
                );
                console.log('스태프리스트', data);
                data.forEach((g) => {
                    this.staffNameList.push(g.name);
                    this.staffNameValueList.push(g.centerStaffId);
                });
            } catch (error) {
                console.log(error);
                console.log('에러입니다.');
            }
        },
        // 스태프 리스트 조회 API
        getfetchStaffList() {
            return api.get(`/admin/api/center/${this.centerId}/staff/teachers/list`);
        },
        // 강사 리스트 조회
        async onFetchTeachers() {
            try {
                const { data } = await this.getFetchTeachers();
                data.sort(
                    (
                        a,
                        b // order by 정렬
                    ) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0)
                );
                console.log('강사 리스트', data);
                data.forEach((g) => {
                    this.teacherList.push(g.name);
                    this.teacherValueList.push(g.centerStaffId);
                });
            } catch (error) {
                console.log(error);
                console.log('에러입니다.');
            }
        },
        // 강사 리스트 조회 api
        getFetchTeachers() {
            return api.get(`/admin/api/center/${this.centerId}/staff/teachers/list`);
        },
        // 상단 검색 조건 초기화
        resetSearchFilter() {
            this.ticketType = '';
            this.category = '';
            this.prod = '';
            EventBus.$emit('event:initList', 'init');
        },
        // 하단 검색 조건 초기화
        resetSearchContent() {
            this.teacherStaff = '';
            this.saleStaff = '';
            this.returnType = '';
            this.searchType = '';
            EventBus.$emit('event:initList', 'init');
        },
        // 카테고리명 조회
        async onCategoryList() {
            try {
                const { data } = await this.getCategoryList();
                console.log(data);
                data.forEach((g) => {
                    this.categoryList.push(g.name);
                    this.categoryValList.push(g.centerProductCategoryTemplateId);
                });
            } catch (error) {
                console.log(error);
                console.log('카테고리 값을 가져오는데 실패했습니다.');
            }
        },
        getCategoryList() {
            return api.get(`/admin/api/center/${this.centerId}/product/category/template`);
        },
        // 이용권명 조회
        async onProductList() {
            try {
                const { data } = await this.getProductList();
                console.log('이용권명', data);
                data.items.forEach((g) => {
                    this.prodList.push(
                        `[${
                            {
                                P: '개인',
                                G: '그룹',
                                C: '쿠폰',
                                T: '회원권',
                                D: '듀엣',
                                O: 'OT',
                                S: '운동복',
                            }[g.cp_ticket_type_cd]
                        }] ${g.cp_namee}`
                    );
                    this.prodValList.push(g.cp_center_prod_id);
                });
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },
        getProductList() {
            return api.get(`/admin/api/center/${this.centerId}/product/ticket`, {
                params: {
                    ...this.pagingInfo,
                },
            });
        },
        convertTicket(val) {
            switch (val) {
                case 'P':
                    return '[개인]';
                case 'D':
                    return '[듀엣]';
                case 'O':
                    return '[OT]';
                case 'G':
                    return '[그룹]';
                case 'C':
                    return '[쿠폰]';
                case 'T':
                    return '[회원권]';
                case 'S':
                    return '[운동복]';
                case null:
                    return '';
            }
        },
        // 소속 체인점 센터 조회
        async fetchChainCenter() {
            try {
                const { data } = await this.sendGetChainCenter();
                data.forEach((c) => {
                    this.chainCenterType.push(c.centerName);
                    this.chainCenterTypeValue.push(c.id);
                });
            } catch (error) {
                console.log(error);
            }
        },

        // 소속 체인점 센터 조회 API 호출
        sendGetChainCenter() {
            return api.get(`/admin/api/center/${this.cId}/chain`);
        },
        numberFormat(number) {
            if (number === null || number === '' || number === undefined) {
                return number;
            }

            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },

        // 환불 삭제 버튼 클릭시
        async onClickCancleReturn() {
            try {
                if (!confirm('이용권 환불을 취소하시겠습니까?')) {
                    return false;
                }
                await this.sendPutCancleReturn();
                alert('환불이 취소 되었습니다.');
                this.refundPop = false;
                await this.onSearchList(); // 리프레쉬
            } catch (error) {
                alert('환불 삭제 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 환불 취소 요청 API 호출
        sendPutCancleReturn() {
            return api.put(
                `/admin/api/center/${this.centerId}/customer/${this.refundUserInfo.ccp_center_cust_id}/contract/${this.refundUserInfo.ccp_center_contract_id}/product/${this.refundUserInfo.ccp_center_prod_id}/cancel-retrun`
            );
        },
    },
};
</script>
<style lang="scss"></style>
